import React, { useState } from "react";
import { Button, ButtonGroup, Card, Stack } from "@chakra-ui/react";
import { t } from "i18next";
import { observer } from "mobx-react";
import { ProseMirrorWrapper } from "./ProseMirrorWrapper";
import { OsaComment } from "../../models/OsaComment";
import { useStores } from "../../../shared/stores/RootStore";
import { toast } from "../../../shared/views/CustomToaster";

interface Props {
  osaWayId: string;
  mainThread?: OsaComment;
  nodeId?: string;
  onClose?: () => void;
}
const CommentCreatorBase: React.FC<Props> = ({
  mainThread,
  nodeId,
  osaWayId,
  onClose,
}) => {
  const { osaCommentStore } = useStores();
  const [markdown, setMarkdown] = useState("");

  const submitComment = () => {
    if (markdown) {
      osaCommentStore.postComment({
        osaWayId: mainThread?.osaWayId ?? osaWayId,
        osaNodeId: nodeId ?? null,
        content: markdown,
        mainThreadId: mainThread?.id ?? null,
      });
      onClose?.();
    } else {
      toast("error", t(`map:comments.emptySubmit`));
    }
  };

  return (
    <Stack gap={2}>
      <Card.Root variant="outline">
        <ProseMirrorWrapper defaultContent={""} onChange={setMarkdown} />
      </Card.Root>
      <ButtonGroup
        size="sm"
        alignSelf="end"
        colorPalette="primary"
        fontSize="sm"
      >
        {!!onClose && (
          <Button variant="ghost" onClick={onClose}>
            {t(`map:comments.cancel`)}
          </Button>
        )}
        <Button onClick={submitComment}>
          {mainThread ? t(`map:comments.reply`) : t(`map:comments.submit`)}
        </Button>
      </ButtonGroup>
    </Stack>
  );
};

export const CommentCreator = observer(CommentCreatorBase);
